export {
  fetchMentorshipProgramDetail,
  fetchMentorshipProgramsList,
  postMentorshipApply,
  postMentorshipSurvey,
} from '@/features/mentorship/api/mentorship.api';

export {
  mentorshipQueryKeys,
  useMentorshipProgramsList,
} from '@/features/mentorship/api/mentorship.queries';
